import React, { useEffect, useState } from 'react';
import { Select, MenuItem, FormControl, Box, Typography } from '@mui/material';
import { CONFIG } from '../constants';
import {red} from "@mui/material/colors";

const MissingCows = () => {
  const [items, setItems] = useState([]);
  const [lastSeenValue, setLastSeenValue] = useState(3);

  const fetchData = (value) => {
    fetch(`${CONFIG.backendUrl}/api/missing/${value}`)
      .then((response) => response.json())
      .then((data) => setItems(data))
      .catch((error) => console.error('Error fetching data:', error));
  };

  useEffect(() => {
    fetchData(lastSeenValue);
  }, [lastSeenValue]);

  const handleDropdownChange = (event) => {
    setLastSeenValue(event.target.value);
  };

  return (
    <Box sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        Utolsó{' '}
        <FormControl variant="standard" sx={{ minWidth: 60 }}>
          <Select value={lastSeenValue} onChange={handleDropdownChange}>
            {Array.from({ length: 12 }, (_, i) => i + 1).map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>{' '}
        órában NEM látott tehenek: <strong> <span style={{color: "red"}}>{items.length} db</span></strong>
      </Typography>

      <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
        {items.map((item, index) => (
          <li
            key={index}
            style={{
              textAlign: 'center',
              margin: '10px 0',
              fontSize: '18px',
              fontWeight: '500',
            }}
          >
            <span>
              {item.secondary_id}
            </span> - <span  style={{ marginLeft: '12px', color: '#555' }}>{item.id}</span>
          </li>
        ))}
      </Box>
    </Box>
  );
};

export default MissingCows;
